/*
 *  FIELD_NAMES indicates the expected content of the form field matching the field's `fieldName` property
 */

const FIELD_NAMES = {
  DATE_OF_BIRTH: 'dob'
}

export default FIELD_NAMES
